module.exports = __webpack_public_path__ + "assets/GT-America-Extended-Bold.woff2";


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/fonts/GT-America-Extended-Bold.woff2
// module id = 993
// module chunks = 19